import { createContext, useContext } from 'react';

interface FilterGroupContextValue {
  openFilterId: string | null;
  setOpenFilterId: (id: string | null) => void;
}

export const FilterGroupContext = createContext<FilterGroupContextValue | null>(null);

export const useFilterGroup = () => useContext(FilterGroupContext);
